import React from 'react';
import Helmet from 'react-helmet';

const MetaInfo = (props) => {

    return (
        <>
            {props.lang !== 'fr' ?
                <Helmet>
                    <title>Our Coffee</title>
                    <meta name="description" content="At A&W, we only serve Organic Fairtrade† coffee." />
                </Helmet>
            :
                <Helmet>
                    <title>Notre café</title>
                    <meta name="description" content="Chez A&W, nous ne servons que du café biologique équitable." />
                </Helmet>
            }
        </>
    )
}
export default MetaInfo;